import { tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SidebarBookingRequestsSummaryController extends BaseController {
  @tracked bookingRequest!: ModelRegistry['booking-request'];
}
